<div class="member-search">
  <ng-container *ngIf="options.heading && !isSearchFromPopup">
    <h1>{{ options.heading }}</h1>
    <hr />
  </ng-container>
  <h3 *ngIf="options?.heading2">{{ options.heading2 }}</h3>
  <div class="container" *ngIf="options">
    <form [formGroup]="searchForm">
      <div class="search-controls">
        <div class="ods-form-field {{ control.class }}" *ngFor="let control of options.controls">
          <div class="label-container">
            <label for="{{ control.fieldName }}" [id]="control.fieldName + 'SearchLabel'">
              {{ control.label }}

              @if(control.subtext) {
                <span>{{ control.subtext }}</span>
              }
            </label>
            <div *ngIf="control.tooltipHtml">
              <app-tooltip id="idTooltip" ariaLabel="Id Search Tool tip" width="10rem" position="top">
                <div class="tooltip-content" [innerHTML]="control.tooltipHtml"></div>
              </app-tooltip>
            </div>
          </div>
          <ng-container [ngSwitch]="control.fieldType">
            <ng-container *ngSwitchCase="'text'">
              <input
                #searchField
                (focus)="focused.emit()"
                (focusout)="validateInput()"
                [maxLength]="control.maxLength ? control.maxLength : idLength"
                [attr.aria-errormessage]="control.formControlName + '-error'"
                [attr.aria-invalid]="validationErrors && validationErrors[control.fieldName] ? true : false "
                [attr.aria-label]="control.fieldName"
                class="ods-text-input"
                formControlName="{{ control.formControlName }}"
                [id]="control.fieldName"
                [name]="control.fieldName"
                type="text"
                autocomplete="off"
                [pattern]="control.pattern"
                [polAdminMaskInput]="control.inputMask ? control.inputMask : 'alphaNumeric'"
                (keyup.enter)="search()"
                [autofocusDirective]="control.autofocus"
              />
            </ng-container>
            <ng-container *ngSwitchCase="'email'">
              <input
                #searchField
                (focus)="focused.emit()"
                (focusout)="validateInput()"
                [maxLength]="inputFieldMaxLenght"
                [attr.aria-errormessage]="control.formControlName + '-error'"
                [attr.aria-invalid]="validationErrors && validationErrors[control.fieldName] ? true : false "
                [attr.aria-label]="control.fieldName"
                class="ods-text-input"
                formControlName="{{ control.formControlName }}"
                [id]="control.fieldName"
                [name]="control.fieldName"
                type="text"
                autocomplete="off"
                [pattern]="control.pattern"
                (keyup.enter)="search()"
                [autofocusDirective]="control.autofocus"
              />
            </ng-container>
            <ng-container *ngSwitchCase="'autocomplete'">
              <div class="ods-form-field">
                <typeahead-dropdown
                  #searchField
                  (focus)="focused.emit()"
                  (focusout)="validateInput()"
                  (keyup.enter)="search()"
                  ngDefaultControl
                  formControlName="{{ control.formControlName }}"
                  [attr.aria-errormessage]="control.formControlName + '-error'"
                  [ariainvalid]="validationErrors && validationErrors[control.fieldName] ? true : false"
                  (change)="handleTypeaheadSearch(control.formControlName, $event.detail.value)"
                  (select)="handleTypeaheadSearch(control.formControlName, $event.detail.value, false)"
                  (optionSelected)="searchOnSelection ? onSearch.emit($event.detail) : ''"
                  [options]="
                    typeheadSearchResults && typeheadSearchResults[control.formControlName]?.values
                      ? typeheadSearchResults[control.formControlName].values
                      : []
                  "
                  [currentValue]="control.initialValue"
                  [placeholder]="control.placeholder"
                  class="no-icon"
                  [name]="control.fieldName"
                  id="{{ control.fieldName }}"
                  [attr.aria-label]="control.label"
                  [autofocusDirective]="control.autofocus"
                >
                </typeahead-dropdown>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <div class="ods-form-field">
                <input
                  #searchField
                  (change)="updateDateInputValidity($event, control.formControlName)"
                  (blur)="updateDateInputValidity($event, control.formControlName)"
                  (focus)="focused.emit()"
                  (focusout)="validateInput()"
                  (keydown.enter)="!validateInput() && search()"
                  #DobControl
                  [attr.aria-label]="control.label"
                  [attr.aria-errormessage]="control.formControlName + '-error'"
                  [attr.aria-invalid]="validationErrors && validationErrors[control.fieldName] ? true : false "
                  [attr.aria-labelledby]=""
                  class="ods-text-input date-input"
                  formControlName="{{ control.formControlName }}"
                  [id]="control.fieldName"
                  type="date"
                  [attr.min]="minDate"
                  max="9999-12-31"
                  autocomplete="off"
                  #dateInput
                  [autofocusDirective]="control.autofocus"
                  [class]="control.class"
                />
              </div>
            </ng-container>
          </ng-container>
          <div aria-live="polite">
            <span
              [id]="control.fieldName + '-error'" class="validation-error"
              *ngIf="validationErrors && validationErrors[control.fieldName]"
            >
              {{validationErrors[control.fieldName]}}
            </span>
          </div>
        </div>
      </div>

      <div class="search-actions" *ngIf="showActions">
        <ods-button #searchButton id="searchBtn" (click)="search()">Search</ods-button>
        <ods-button id="resetBtn" (click)="reset()" variant="{{isSearchFromPopup ? 'tertiary' : 'ghost'}}">Reset</ods-button>
        <ods-button id="cancelBtn" *ngIf="isSearchFromPopup" (click)="cancel()" variant="tertiary">Cancel</ods-button>
      </div>
    </form>
  </div>
</div>
